
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { TextureLoader } from 'three';
import { LoadingManager } from 'three';

export class Loader3d {


	#manager = null;
	#loader = null;
	#fLoader = null;
	#fontPath = null;
	#font = null;
	#tLoader = null;

	constructor() {

		// add version to any call made by the loader
		this.#manager = new LoadingManager();
		this.#manager.setURLModifier( ( url ) => url + window.version );

		//add draco loader for compression
		const draco = new DRACOLoader();
		draco.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
		
		//create gltf loader
		this.#loader = new GLTFLoader( this.#manager );
		this.#loader.setDRACOLoader(draco);

		//Font Load
		this.#fLoader = new FontLoader();
		this.#fontPath = 'public/Raleway_Regular.json';
		this.#font = null;

		//texture loader
		this.#tLoader = new TextureLoader();

	}
    
	async load( path ) {
		return await new Promise( ( resolve ) => this.#loader.load( path, resolve ) );
	}
	

	async loadFont( url ) {
		let real_url = url;
		if( !url || url === '' || url === this.#fontPath ) {
			if( this.#font ) return this.#font;
			real_url = this.#fontPath;
		}

		this.#font = await this.#fLoader.loadAsync( real_url );
		return this.#font;
	}

	async loadTexture( url ) {
		return await this.#tLoader.loadAsync( url );
	}
}